import { FormSection } from "Backend";
import { ReactNode } from "react";
import { useAppSelector } from "redux/hooks";
import { selectFormSectionsMap } from "redux/slices/form.slice";

export function SectionFromId({
  sectionId,
  children,
}: {
  sectionId: number;
  children: (section?: FormSection) => ReactNode;
}) {
  const formSectionsMap = useAppSelector(selectFormSectionsMap);

  return children(formSectionsMap.get(sectionId));
}
